import React, { useState } from 'react';
import PropTypes from 'prop-types';

import VideoPreviewModal from '../VideoPreviewModal';

const THUMB_WIDTH_PX = 180;

// Composer chip for an attached video: a thumbnail with a play button (opens a preview so the user
// can watch before sending) and a trash button. While uploading direct-to-Cloudinary it shows a
// progress overlay instead of the play button. Preview plays the local blob (instant, no round-trip).
function VideoAttachmentItem({
 filename, src = null, progress = null, onRemove,
}) {
  const [showPreview, setShowPreview] = useState(false);
  // Any non-null progress means in-flight: bytes hit 100% before Cloudinary's response arrives,
  // and until then this chip has no remove handler — so it must keep looking (and being) inert.
  const uploading = progress !== null;
  const pct = Math.round((progress ?? 0) * 100);

  return (
    <>
      <div className="position-relative" style={{ width: THUMB_WIDTH_PX }}>
        <video
          src={src || undefined}
          muted
          preload="metadata"
          className="rounded w-100"
          style={{
 aspectRatio: '16 / 9', objectFit: 'cover', background: '#000', display: 'block',
}}
        >
          <track kind="captions" />
        </video>

        {uploading ? (
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center rounded px-3"
            style={{ background: 'rgba(0,0,0,.5)' }}
            role="progressbar"
            aria-label={`Uploading ${filename}`}
            aria-valuenow={pct}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <small className="text-white">{pct}%</small>
            <div className="progress w-100 mt-1" style={{ height: 4 }}>
              <div className="progress-bar" style={{ width: `${pct}%` }} />
            </div>
          </div>
        ) : (
          <button
            type="button"
            className="btn position-absolute top-50 start-50 translate-middle rounded-circle d-flex align-items-center justify-content-center p-0"
            style={{ width: 44, height: 44, background: 'rgba(255,255,255,.9)' }}
            title={`Play ${filename}`}
            aria-label={`Play ${filename}`}
            onClick={() => setShowPreview(true)}
            onMouseDown={(e) => e.preventDefault()}
          >
            <i className="fa-solid fa-play text-dark" />
          </button>
        )}

        <button
          type="button"
          className="btn position-absolute top-0 end-0 m-1 rounded-circle d-flex align-items-center justify-content-center p-0"
          style={{ width: 28, height: 28, background: 'rgba(0,0,0,.55)' }}
          title={`Remove ${filename}`}
          aria-label={`Remove ${filename}`}
          onClick={onRemove}
          onMouseDown={(e) => e.preventDefault()}
          disabled={uploading}
        >
          <i className="fa-solid fa-trash text-white" style={{ fontSize: 12 }} />
        </button>
      </div>

      <VideoPreviewModal show={showPreview} onHide={() => setShowPreview(false)} src={src} title={filename} />
    </>
  );
}

VideoAttachmentItem.propTypes = {
  filename: PropTypes.string.isRequired,
  src: PropTypes.string,
  progress: PropTypes.number,
  onRemove: PropTypes.func,
};

export default VideoAttachmentItem;
